import dashboard from './dashboard'

// Array of sections
export default [
    ...dashboard
]
